"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuToggler = exports.MenuHeaderInner = exports.MenuHeaderContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MenuHeaderContainer = exports.MenuHeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuHeaderContainer",
  componentId: "sc-uh83ss-0"
})(["height:", ";background-color:", ";color:", ";position:relative;padding:", ";"], ({
  theme
}) => theme.AppFrame.menu.header.height, ({
  theme
}) => theme.colors.appFrame.menu.headerBg, ({
  theme
}) => theme.colors.appFrame.menu.headerText, ({
  collapsed
}) => collapsed ? '0' : '0 16px');
const MenuHeaderInner = exports.MenuHeaderInner = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuHeaderInner",
  componentId: "sc-uh83ss-1"
})(["border-bottom-width:1px;border-style:solid;border-color:", ";height:100%;transition:border-color 0.3s ease-in-out;display:flex;flex-direction:row;align-items:center;", ";"], ({
  theme
}) => theme.colors.appFrame.menu.line, ({
  collapsed
}) => collapsed && (0, _styledComponents.css)(["border-color:transparent;"]));
const MenuToggler = exports.MenuToggler = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuToggler",
  componentId: "sc-uh83ss-2"
})(["cursor:pointer;position:absolute;top:50%;transform:translateY(-50%);left:calc((", " - 32px) / 2);width:32px;height:32px;z-index:100;& span{bottom:auto;left:50%;right:auto;top:50%;transform:translateX(-50%) translateY(-50%);position:absolute;width:22px;height:2px;border-radius:1px;background-color:transparent;transition:background-color 0.3s ease-in-out;&:before,&:after{content:'';width:22px;height:2px;border-radius:1px;background-color:", ";position:absolute;transition:transform 0.3s ease-in-out;}&:before{transform:rotate(-45deg);}&:after{transform:rotate(45deg);}}", ";"], ({
  theme
}) => theme.AppFrame.menu.collapsedWidth, ({
  theme
}) => theme.colors.appFrame.menu.toggler, ({
  collapsed,
  theme
}) => collapsed && (0, _styledComponents.css)(["& span{background-color:", ";&:before{transform:translateY(-7px);}&:after{transform:translateY(7px);}}"], theme.colors.appFrame.menu.toggler));